import axios from "axios";
import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import Form from 'react-bootstrap/Form';
import {useNavigate } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import { checklogin } from "../slices/userSlice";
import  {useSelector, useDispatch } from "react-redux";
import "../css/login-SA.css"
import Col from 'react-bootstrap/Col';
import Navbar from 'react-bootstrap/Navbar';
import Logo from '../images/logos.png'
import Row from 'react-bootstrap/Row';




function SALOGIN(){
    
const login=useSelector((state)=>state.user.loginValue)
const Navigate=useNavigate()
const dispatch=useDispatch()
    
           
        let formData=new FormData()
        formData.append("email",login.email)
        formData.append("password",login.password)
        
        const getdata=()=>{

        
        axios.post('https://agaram.academy/api/retail/index.php?request=super_admin_login',formData)

        .then(function(response){
            
                if(response.data.status=="success"){

                localStorage.setItem("token",response.data.token)
                Navigate("/ownerslist")
            }
            else{
                alert("wrong username/password")
            }

        })
        }
   

return(
    <>
   
    <div className='login template  bg'>
                <div className='logopositions'>
                    <Navbar >
                        <Navbar.Brand href="#"><img src={Logo} alt='logo' width={90} id="logo" /></Navbar.Brand>

                    </Navbar>
                </div>
               
                    <div className='positionchange'>
                        <Form style={{minWidth:"350px",maxWidth:"600px"}} className='p-3'>
                            <h1 className='text-start mb-3'> login page </h1>
                            
                            <div>
                                <Form.Group as={Row} className="mb-3 mailbox" controlId="formPlaintextPassword">
                                    <Form.Label column sm="3">
                                        Email
                                    </Form.Label>
                                    <Col sm="10">
                                        <Form.Control type="email" name='email' placeholder="email" className='detail' required onKeyUp={(e)=>dispatch(checklogin({
    ...login,
    email:e.target.value}))}/>
                                        {/* {error.email && <span style={{ color: "red" }}>{error.email}</span>} */}
                                    </Col>
                                </Form.Group>

                                <Form.Group as={Row} className="mb-3 pasbox" controlId="formPlaintextPassword">
                                    <Form.Label column sm="3">
                                        Password
                                    </Form.Label>
                                    <Col sm="10">
                                        <Form.Control type="password" 
                                        name='password'
                                        placeholder="Password"
                                        className='detail' 
                                        required id="password"  
                                        onKeyUp={(e)=>dispatch(checklogin({
            ...login,
            password:e.target.value
        }))} />
                                        {/* {error.password && <span style={{ color: "red" }}>{error.password}</span>} */}
                                    </Col>
                                </Form.Group>
                            </div>
                            
                            <div className='d-flex justify-content-start '>
                                <button className='btn btn-success px-4 my-3' type='button' onClick={()=>getdata()}>Register</button>

                            </div>
                        </Form>
                    </div>
                </div>


   
  
         
       

     
      
</>
)
}
export default SALOGIN;